import classnames from "classnames";

import { useIsOverflowing } from "shared/hooks";

import Tooltip from "features/components/Tooltip";

interface Props {
  value: string;
  breakWords?: boolean;
  multiLine?: boolean;
}

const OverflowText = ({ value, breakWords, multiLine = false }: Props) => {
  const { ref: textRef, isOverflowing } = useIsOverflowing();

  if (!value) {
    return null;
  }

  const content = (
    <div
      className={classnames("overflow-hidden text-ellipsis", {
        "break-words": breakWords,
        "whitespace-nowrap": !breakWords && !multiLine,
        "whitespace-normal": multiLine,
        "line-clamp-2": multiLine,
      })}
      style={{ flex: "0 1 auto" }}
      ref={textRef}
    >
      {value}
    </div>
  );

  return (
    <div className="flex flex-row items-center w-full justify-start">
      {isOverflowing ? (
        <Tooltip title={value} placement="bottom-start" enterDelay={750}>
          <div className="w-full">{content}</div>
        </Tooltip>
      ) : (
        content
      )}
    </div>
  );
};

export default OverflowText;
